"use client";
import { useMutation } from "@apollo/client";
import { useAtom } from "jotai";

import { logoutMutation } from "@/components/model/user/_graphql";

import { authAtom } from "@/globalState/authState";
import { setAccessTokenInMemory } from "@/libs/apollo/provider";
import type { AuthTokenExpires } from "@/util/auth/refreshAuthResult";
import { removeAuthTokens, setAuthToken, setAuthTokens } from "@/util/cookies";

export const useLogin = () => {
  const [isLogin, setIsLogin] = useAtom(authAtom);
  const login = async (
    token: string,
    refreshToken?: string | null,
    expires?: AuthTokenExpires,
  ) => {
    if (!token) {
      console.error("トークンが空です");
      throw new Error("トークンが空です");
    }

    try {
      if (refreshToken) {
        await setAuthTokens(token, refreshToken, expires);
      } else {
        // 旧セッション互換（リフレッシュトークンなし）
        await setAuthToken(token, expires?.tokenExpireAt);
      }
      setAccessTokenInMemory(token);
      await setIsLogin(true);
      return true;
    } catch (error) {
      console.error("login処理エラー:", error);
      throw error;
    }
  };

  return { isLogin, login };
};

export const useLogout = () => {
  const [isLogin, setLogin] = useAtom(authAtom);
  const [mutation, { client }] = useMutation(logoutMutation);
  const logout = async () => {
    if (!isLogin) return;
    try {
      await mutation();
    } catch (error) {
      console.error("logout mutation error:", error);
    }
    await client.clearStore();
    await removeAuthTokens();
    setAccessTokenInMemory(null);
    await setLogin(false);
  };

  return { isLogin, logout };
};
